import './index.scss';

const yugacrewSvg = '/assets/images/yugacrew.svg';
const momentStudioSvg = '/assets/images/3ha-logo_full.svg';

const ProjectItem = ({ title, term, contribution, outcomes, details, image, mobileImage, imageAlt, company }) => {
  const companyLogo = company === '육아크루' ? yugacrewSvg : company === '모먼트스튜디오' ? momentStudioSvg : null;

  return (
    <article className='project-card'>
      <div className='project-overview'>
        <div className='project-summary'>
          {companyLogo && (
            <div className='project-company'>
              <img src={companyLogo} alt={company} className='project-company-logo' />
            </div>
          )}
          <h3 className='project-title'>{title}</h3>
          <p className='project-term'>{term}</p>
          <p className='project-contribution'>기여도 : {contribution}</p>
        </div>
        {image && (
          <figure className='project-image'>
            <picture>
              {mobileImage && <source media='(max-width: 768px)' srcSet={mobileImage} />}
              <img src={image} alt={imageAlt || `${title} 이미지`} />
            </picture>
          </figure>
        )}
      </div>

      <div className='project-content'>
        <section className='project-group'>
          <h4>프로젝트 성과</h4>
          <ul>
            {outcomes.map((outcome) => (
              <li key={outcome}>{outcome}</li>
            ))}
          </ul>
        </section>

        <section className='project-group'>
          <h4>주요 업무 내용</h4>
          <ul>
            {details.map((detail) => (
              <li key={detail}>{detail}</li>
            ))}
          </ul>
        </section>
      </div>
    </article>
  );
};

export default ProjectItem;
